export const appRoutes = (params) => ({
  login: '/auth/login',
  signup: '/auth/sign-up',
  checkEmail: '/auth/check-email',
  forgotPassword: '/auth/forgot-password',
  verifyEmail: '/auth/verify-email',
  subscriptionSuspended: '/subscription-suspended',
  subscription: '/subscription',
  invitation: '/invitation',
  payment: '/payment',
  invoices: '/invoices',
  alerts: '/alerts',
  userAttendance: '/userAttendance',
  addCompany: '/add-company',
  selectCompany: '/select-company',
  dashboardOverview: '/dashboard-overview',
  dashboardOverviewNew: '/user-dashboard',
  timeline: '/timeline',
  notifications: '/notifications',
  screenshots: '/screenshots',

  appUsage: '/app-usage',
  urlTracking: '/url-tracking',
  teamsTimeline: '/teams-timeline',
  teamsReporting: '/teams-reporting',
  usersData: '/users-data',
  manageSettings: '/manage-settings',
  teamAttendance: '/team-attendance',
  addEmployee: '/add-employee',
  employeeList: '/employee-list',
  teamList: '/departments',
  invitationsHub: '/invitations-hub',
  integrations: '/integrations',
  integrationsQuickBooks: '/integrations/quickbooks',
  integrationsSalesforce: '/integrations/salesforce',
  integrationsKeka: '/integrations/keka',
  integrationsJira: '/integrations/jira',
  integrationsSageHR: '/integrations/sagehr',
  integrationsZohoPeople: '/integrations/zohopeople',
  downloadDesktopApp: '/download-desktop-app',
  project: '/project',

  invites: `/invites/${params?.id ?? ':id'}`,
  inviteesList: '/inviteesList',
  manageTasks: '/manage-tasks',
  addTask: '/add-task',
  updateTask: `/task/${params?.projectName ?? ':projectName'}/${
    params?.taskId ?? ':taskId'
  }`,
  profile: '/profile',
  regularization: '/regularization',
  requestsRegularization: '/requestsregularization',
  leave: '/leave',
  requestsLeave: '/requestsleave',
  onboarding: '/onboarding',
  teamDashboard: '/department-dashboard',
});
